import { useCallback } from 'react';
import { format, subYears } from 'date-fns';
import { getBankConnections, getBalanceHistory } from 'actions';
import { getALLBalanceHistory } from 'actions/balanceHistory';
import { useAppDispatch } from 'store/hooks';
const addBalanceHistoryAccountType = (type, balanceHistoryTypes, allGraphSections) => {
    switch (type) {
        case 'CRYPTO':
        case 'INVESTMENT':
            balanceHistoryTypes.add('INVESTMENT');
            allGraphSections.add('INVESTMENT');
            break;
        case 'SAVINGS':
            balanceHistoryTypes.add('SAVINGS');
            allGraphSections.add('SAVINGS');
            break;
        case 'CHECKING':
        case 'CREDITCARD':
            balanceHistoryTypes.add('CHECKING');
            allGraphSections.add('EVERYDAY');
            break;
        default:
            break;
    }
};
const useRefreshAccounts = () => {
    const dispatch = useAppDispatch();
    const refresh = useCallback((currentType, previousType) => {
        const toNow = format(new Date(), 'yyyy-MM-dd');
        const fromLastYear = format(subYears(new Date(), 1), 'yyyy-MM-dd');
        dispatch(getBankConnections());
        const balanceHistoryTypes = new Set();
        const allGraphSections = new Set();
        const currentTypes = Array.isArray(currentType)
            ? currentType
            : [currentType];
        currentTypes.forEach((type) => addBalanceHistoryAccountType(type, balanceHistoryTypes, allGraphSections));
        if (previousType) {
            addBalanceHistoryAccountType(previousType, balanceHistoryTypes, allGraphSections);
        }
        balanceHistoryTypes.forEach((balanceHistoryType) => {
            dispatch(getBalanceHistory(fromLastYear, toNow, balanceHistoryType, '1day'));
        });
        allGraphSections.forEach((graphSection) => {
            dispatch(getALLBalanceHistory(graphSection));
        });
        // These calls are always needed as they can include any of the account types
        dispatch(getBalanceHistory(fromLastYear, toNow, 'NETWORTH', '1day'));
        dispatch(getBalanceHistory(fromLastYear, toNow, 'ASSETS', '1day'));
        dispatch(getBalanceHistory(fromLastYear, toNow, 'DEBT', '1day'));
        dispatch(getALLBalanceHistory('NET_WORTH'));
        dispatch(getALLBalanceHistory('NET_WORTH', 'ASSET'));
        dispatch(getALLBalanceHistory('NET_WORTH', 'DEBT'));
    }, []);
    return refresh;
};
export default useRefreshAccounts;
